<kt-portlet>

    <kt-portlet-header [class]="'card-head-lg'">
        <ng-container ktPortletTitle>
            <h3 class="card-label">
                <span>Generate audit report</span>
            </h3>
        </ng-container>
    </kt-portlet-header>

    <kt-portlet-body>
        <mat-dialog-content>
            <form class="form">
                <div class="example-container mat-elevation-z0 col-lg-12 kt-margin-bottom-10-mobile mt-4 mb-4">
                    <mat-table #table [dataSource]="dataSourceGeneratedReport">
        
                        <ng-container matColumnDef="created_at">
                            <mat-header-cell *matHeaderCellDef>Generated Date</mat-header-cell>
                            <!-- <mat-cell *matCellDef="let report"> {{report.created_at|date: 'dd MMM yyyy':currentUser?.settings.time_zone_gmt}}</mat-cell> -->
                            <mat-cell *matCellDef="let report"> {{report.created_at|date: 'dd MMM yyyy'}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="file_size">
                            <mat-header-cell *matHeaderCellDef>Size of the file</mat-header-cell>
                            <mat-cell *matCellDef="let report"> {{report.file_size}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="including_not_signed">
                            <mat-header-cell *matHeaderCellDef>Inlcuding Not Signed?</mat-header-cell>
                            <mat-cell *matCellDef="let report"> {{report.includesOnlySignedToe ? 'No' : 'Yes'}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <mat-header-cell *matHeaderCellDef>Report Status</mat-header-cell>
                            <mat-cell *matCellDef="let report"> 
                                <b><span
                                    class="label label-inline label-rounded label-outline-{{ getItemCssClassByStatus(report.status) }} label-outline-2x label-lg py-1"
                                    style="width: 10rem;">{{report.status == 1 ? 'success' : report.status == 0 ? 'in progress' : 'failed'}}
                                </span></b>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                            <mat-cell *matCellDef="let report; let i = index;">
                                <button mat-icon-button
                                        color="primary"
                                        matTooltip="Download Generated Report"
                                        (click)="downloadAuditTrailReport(report, i)"
                                        type="button"
                                        [disabled]="report.status != 1">
                                    <mat-icon>get_app</mat-icon>
                                </button>&nbsp;
        
                                <button mat-icon-button
                                        color="warn"
                                        matTooltip="Delete Generated Report"
                                        type="button"
                                        (click)="deleteAuditTrailReport(report, i)">
                                    <mat-icon>delete</mat-icon>
                                </button>&nbsp;
        
                            </mat-cell>
                            
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="displayedColumnsGeneratedReport"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumnsGeneratedReport;"></mat-row>
                    </mat-table>
                </div>
            </form>
        </mat-dialog-content>
        <div class="card-footer text-right">
            <div class="form-actions form-actions-solid my-2s">
                <button mat-button mat-raised-button (click)="onClickClose()">Close</button>&nbsp;
                <button type="button"
                        class="btn btn-success"
                        [disabled]="generating"
                        mat-raised-button color="submit"
                        (click)="onSubmit()"
                        matTooltip="Download generated report file">
                        Generate a New Audit Trail
                </button>
            </div>
        </div>
    </kt-portlet-body>

</kt-portlet>
